import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AclEntries } from '@app/core/interfaces/portal/acl-entries';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { CallBarringViewModel } from '@business/call-barring/models/call-barring-view-model';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TrunkCallBarringRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(userId: string, direction: string, callBarring: CallBarringViewModel) {
    return this.utils.apiUrl(this.getUrl(userId, direction)).pipe(
      mergeMap((url) => this.http.post<void>(url, callBarring)),
      wrapError('trunk: add call-barring')
    );
  }

  delete(userId: string, direction: string, id: number) {
    return this.utils.commonApiUrl(this.getUrl(userId, direction, id)).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('trunk: delete call-barring')
    );
  }

  list(userId: string, direction?: string): Observable<AclEntries> {
    return this.utils.commonApiUrl(this.getUrl(userId, direction)).pipe(
      mergeMap((url) => this.http.get<AclEntries>(url)),
      wrapError('trunk: list call-barrings')
    );
  }

  update(userId: string, direction: string, callBarring: CallBarringViewModel) {
    return this.utils.apiUrl(this.getUrl(userId, direction, callBarring.id)).pipe(
      mergeMap((url) => this.http.put<void>(url, callBarring)),
      wrapError('trunk: update call-barring')
    );
  }

  private getUrl(userId: string, direction?: string, id?: number): string {
    let url: string = `/users/${userId}/aclEntries`;

    if (direction != null) {
      url += `/${direction}`;
    }

    if (id != null) {
      url += `/${id}`;
    }

    return url;
  }
}
